import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function VerificationEmailSent () {
  return (
    <Box p={1} mt={8}>
      <Typography variant="h6">Confirm your email</Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        We sent a confirmation link to your email. Click it to finish signing up
        and sign in. You will not be signed in until the link is confirmed.
      </Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>
        Already confirmed?{" "}
        <Link to="/account/login">
          <b>Sign in</b>
        </Link>
      </Typography>
    </Box>
  );
}
